<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Home page Videos</h4>
                    </div>
                    <div class="card-body">
                        <div>
                            <router-link class="btn btn-primary btn-sm mb-2" to="/AdminSystem/add_home_video"> <i
                                    class="fa fa-plus"></i> Add Videos</router-link>
                        </div>
                        <div class="row mt-5" style="overflow: auto">
                            <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                <table class="table">
                                    <thead class="thead-dark">
                                        <tr>
                                            <th scope="col">Order Number</th>
                                            <th scope="col">Video link</th>
                                            <th scope="col">Status</th>
                                            <th scope="col">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="video in allVideos" :key="video.id">
                                            <td scope="row">{{ video.VideoOrder }}</td>
                                            <td><iframe :src="`${video.Videolink}?title=0&byline=0&portrait=0`" width="auto"
                                                    height="200" frameborder="0" webkitallowfullscreen mozallowfullscreen
                                                    allowfullscreen></iframe></td>
                                            <td>
                                                <button :class="`btn btn-sm ${video.Active == 1 ? 'btn-success' : 'btn-warning'}`"
                                                    @click="activeDeactiveHomeVideo(video.id, video.Active)">{{
                                                        video.Active == 1 ? "Active" : "Inactive" }}</button>
                                            </td>
                                            <td>
                                                <button class="btn btn-sm btn-primary mr-1" @click="editVideo(video)">Edit</button>
                                                <button class="btn btn-sm btn-danger" @click="deleteHomeVideo(video.id)">Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import router from '../../router';

export default {
    name: "homepage_video",
    data() {
        return {
            allVideos: {},
        }
    },
    methods: {
        editVideo(video) {
            router.push({ name: "edit_home_video", params: { id: video.id, video: video } })
        },
        activeDeactiveHomeVideo(id, status) {
            let conditionStatus = (status == 1 ? 0 : 1);
            API.activeDeactiveHomeVideo({ status: conditionStatus, id: id }, this.activeDeactiveHomeVideoCB, this.errorCB)
        },
        activeDeactiveHomeVideoCB(res) {
            this.$showNotification(res.data, 'success')
            this.allHomeVideo();
        },
        allHomeVideo() {
            API.allHomeVideo(this.allHomeVideoCB, this.errorCB);
        },
        allHomeVideoCB(res) {
            this.allVideos = res.data.data
            this.$showNotification(res.data, 'success')
        },
        deleteHomeVideo(id) {
            API.deleteHomeVideo({ id }, this.deleteHomeVideoCB, this.errorCB)
        },
        deleteHomeVideoCB(res) {
            this.allHomeVideo();
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.allHomeVideo();
    },
    components: {}
}
</script>
